import axios, { isAxiosError } from "axios";
import {
  buildAxiosAuthenticationHeaders,
  buildAxiosAuthenticationHeadersForMultipart,
} from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import {
  PostSupportCommentByTicketPayload,
  TicketCommentItem,
} from "@src/types/support";

export type PostSupportCommentByTicketResponse = TicketCommentItem;

export const postSupportCommentByTicket = async (
  namespace: string,
  ticketId: string,
  payload: PostSupportCommentByTicketPayload,
): Promise<PostSupportCommentByTicketResponse> => {
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.post<PostSupportCommentByTicketResponse>(
      `${url}/api/v1/ns/${namespace}/tickets/${ticketId}/comments`,
      payload,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to post support comment by ticket. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while posting comment by ticket.",
    );
  }
};

export const postSupportCommentByTicketWithFiles = async (
  namespace: string,
  ticketId: string | number,
  payload: PostSupportCommentByTicketPayload,
  files: File[],
): Promise<PostSupportCommentByTicketResponse> => {
  const url = supportUrlEnvVar();
  // FormData sets its own multipart Content-Type — never send a JSON one.
  const headers = buildAxiosAuthenticationHeadersForMultipart();

  const formData = new FormData();
  formData.append("comment", JSON.stringify(payload));
  for (const file of files) {
    formData.append("files", file);
  }

  try {
    const response = await axios.post<PostSupportCommentByTicketResponse>(
      `${url}/api/v1/ns/${namespace}/tickets/${ticketId}/comments/with-files`,
      formData,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to post support comment by ticket. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while posting comment by ticket.",
    );
  }
};
